import { DeliveryMethods } from 'common/components/delivery-methods';
import { DeliveryInfo } from 'common/components/delivery-methods/components/delivery-info';
import { StoreStockData } from 'common/components/stocks-in-stores/types';
import {
  DeliveryMethod,
  getGoodsSupplyCase,
  GoodsSupplyCase,
  getStocksInStores,
  getStocksUnit,
  getDeliveryMethods,
} from 'features/goods-supply';
import { isWebSellable } from 'features/product-info';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { getRegionName } from 'features/page-model/ducks/get-model';
import { deliveryMethodsWrapper } from './pdp-delivery-methods.styles';

export const DATA_QA_ADELIVERY_METHODS = 'adelivery-methods';

export type DeliveryMethodsMappedState = {
  stocks: StoreStockData[];
  deliveryMethods: DeliveryMethod[];
  supplyCase: GoodsSupplyCase | null;
  isSellable: boolean;
  regionName?: string;
  uom?: string;
};

export type ADeliveryMethodsProps = { isVisible: boolean } & DeliveryMethodsMappedState &
  React.HTMLAttributes<HTMLElement>;
export const ADeliveryMethods: React.FC<ADeliveryMethodsProps> = ({
  deliveryMethods,
  supplyCase,
  isSellable,
  regionName,
  isVisible,
  stocks,
  uom,
}) => {
  const showContent =
    isSellable &&
    supplyCase !== null &&
    ['CASE_3', 'CASE_4', 'CASE_6', 'CASE_7', 'CASE_8'].includes(supplyCase);
  const [maxStockAvailable, setMaxStockAvailable] = React.useState(0);
  useEffect(() => {
    if (!Array.isArray(deliveryMethods)) return;
    deliveryMethods.forEach((method) => {
      if (method && method.maxStockAvailable && method.maxStockAvailable > maxStockAvailable) {
        setMaxStockAvailable(method.maxStockAvailable);
      }
    });
  }, [deliveryMethods, maxStockAvailable]);
  const maxStockPickup = deliveryMethods.find(({ type }) => type === 'PICKUP')?.maxStockAvailable ?? 0;

  return showContent ? (
    <div className={deliveryMethodsWrapper} data-qa={DATA_QA_ADELIVERY_METHODS}>
      <DeliveryInfo
        regionName={regionName}
        maxStockAvailable={maxStockAvailable || maxStockPickup}
        uom={uom}
      />
      {isVisible && <DeliveryMethods options={deliveryMethods} stocks={stocks} />}
    </div>
  ) : null;
};

const mapStoreToProps = (store: RootReducer): DeliveryMethodsMappedState => {
  const stocks = getStocksInStores(store);
  const deliveryMethods = getDeliveryMethods(store);
  const supplyCase = getGoodsSupplyCase(store);
  const isSellable = isWebSellable(store);
  const regionName = getRegionName(store);
  const uom = getStocksUnit(store);

  return {
    deliveryMethods,
    supplyCase,
    isSellable,
    regionName,
    stocks,
    uom,
  };
};

export const PdpDeliveryMethods = connect(mapStoreToProps)(ADeliveryMethods);
